import { render, staticRenderFns } from "./ModalResultadoAvaliacoes.vue?vue&type=template&id=6ad06f00"
import script from "./ModalResultadoAvaliacoes.vue?vue&type=script&lang=js"
export * from "./ModalResultadoAvaliacoes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports